/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpAssessment from './pre-op-assessment';
import PreOpAssessmentDetail from './pre-op-assessment-detail';
import PreOpAssessmentUpdate from './pre-op-assessment-update';
import PreOpAssessmentDeleteDialog from './pre-op-assessment-delete-dialog';

const PreOpAssessmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpAssessment />} />
    <Route path="new" element={<PreOpAssessmentUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpAssessmentDetail />} />
      <Route path="edit" element={<PreOpAssessmentUpdate />} />
      <Route path="delete" element={<PreOpAssessmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpAssessmentRoutes;
